import { ApiError } from '../api/client';

import type { TFunction } from 'i18next';

/**
 * translateError turns any thrown value into a message in the operator's
 * language. The server sends a stable code; the translation lives here, so
 * adding a locale never requires a backend change.
 */
export function translateError(t: TFunction, error: unknown): string {
  if (error instanceof ApiError) {
    // When the server said how long to wait (Retry-After), prefer the
    // "<code>_wait" wording that names the delay. i18next falls back to
    // errors.unknown for a code with no translation.
    const seconds = error.retryAfterSeconds;
    const keys = [`errors.${error.code}`, 'errors.unknown'];
    return t(seconds === undefined ? keys : [`errors.${error.code}_wait`, ...keys], {
      ns: 'common',
      seconds,
    });
  }
  if (error instanceof TypeError) {
    // fetch rejects with TypeError when the request never reached the server.
    return t('errors.network', { ns: 'common' });
  }
  return t('errors.unknown', { ns: 'common' });
}

/** errorReference returns the request id to quote in a support ticket. */
export function errorReference(error: unknown): string | undefined {
  return error instanceof ApiError ? error.requestId : undefined;
}
